import { h } from "@stencil/core";
import { renderShowcaseProperties } from "../utils";
const state = {};
const render = () => (h("ch-progress", { class: "progress", accessibleName: state.accessibleName, accessibleValueText: state.accessibleValueText, indeterminate: state.indeterminate, min: state.min, max: state.max, value: state.value }));
const showcaseRenderProperties = [
    {
        caption: "Properties",
        properties: [
            {
                id: "accessibleName",
                caption: "Accessible Name",
                value: undefined,
                type: "string"
            },
            {
                id: "accessibleValueText",
                caption: "Accessible Value Text",
                value: undefined,
                type: "string"
            },
            {
                id: "min",
                caption: "Min Value",
                value: 0,
                type: "number"
            },
            {
                id: "max",
                caption: "Max Value",
                value: 100,
                type: "number"
            },
            {
                id: "value",
                caption: "Value",
                value: 0,
                type: "number"
            },
            {
                id: "indeterminate",
                caption: "Indeterminate",
                value: false,
                type: "boolean"
            }
        ]
    }
];
const showcasePropertiesInfo = [
    { name: "accessibleName", defaultValue: undefined, type: "string" },
    { name: "accessibleValueText", defaultValue: undefined, type: "string" },
    { name: "indeterminate", defaultValue: false, type: "boolean" },
    { name: "min", defaultValue: 0, type: "number" },
    { name: "max", defaultValue: 100, type: "number" },
    { name: "value", defaultValue: 0, type: "number" }
];
export const progressShowcaseStory = {
    properties: showcaseRenderProperties,
    markupWithoutUIModel: {
        react: () => `<ChProgress${renderShowcaseProperties(state, "react", showcasePropertiesInfo)}
      ></ChProgress>`,
        stencil: () => `<ch-progress${renderShowcaseProperties(state, "stencil", showcasePropertiesInfo)}
        ></ch-progress>`
    },
    render: render,
    state: state
};
